import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { INoteTemplate } from '../../core/interfaces/note.interface';
import { NoteTemplateService } from '../../core/services/note-template.service';
import { Subscription } from 'rxjs/Subscription';
import { T2CardComponent } from '../../trip2-theme/components/t2-card/t2-card.component';
import { GridOptions, GridReadyEvent, RowDoubleClickedEvent } from 'ag-grid';

@Component({
  selector: 'app-note-template-chips',
  templateUrl: './note-template-chips.component.html',
  styleUrls: ['./note-template-chips.component.scss']
})
export class NoteTemplateChipsComponent implements OnInit, OnDestroy {
  @ViewChild('noteListModal') noteListModal: T2CardComponent;
  @Input('qty-of-chips') QtyOfChips = 5;

  destroy: Subscription = new Subscription();
  gridOptions: GridOptions;

  noteTemplateChips: INoteTemplate[] = [];
  noteTemplateList: INoteTemplate[] = [];
  showMoreNoteText = false;
  totalNotes = 0;
  hiddenComponent = true;

  constructor(
    private noteTemplateService: NoteTemplateService
  ) {
    this.initGrid();
  }

  ngOnInit(): void { }

  private setDataToComponent(): void {
    this.destroy.add(
      this.noteTemplateService.noteTemplateData$.subscribe({
        next: (noteTemplates: INoteTemplate[]): void => {
          if (noteTemplates) {
            this.noteTemplateChips = noteTemplates.slice(0, this.QtyOfChips);
            this.noteTemplateList = noteTemplates;
            this.showMoreNoteText = noteTemplates.length > this.QtyOfChips;
            this.totalNotes = noteTemplates.length;
            this.hiddenComponent = !noteTemplates.length;
            this.gridOptions.api.setRowData(noteTemplates);
          }
        }
      })
    );
  }

  initGrid(): void {
    this.gridOptions = <GridOptions> {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: 'multiple',
      columnDefs: [
        {
          colId: 'notetemplateid',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          width: 30,
          hide: true
        },
        {
          headerName: 'Description',
          field: 'description',
          width: 500
        },
        {
          headerName: 'Speed Code',
          field: 'speedcode',
          width: 150
        }
      ],
      onGridReady: (event: GridReadyEvent): void => {
        if (event) {
          this.gridOptions.api.setRowData([]);
          this.gridOptions.api.sizeColumnsToFit();
          this.setDataToComponent();
        }
      },
      onRowDoubleClicked: ({ data }: RowDoubleClickedEvent): void => {
        this.sendLayoutDescriptionNoteAfterClickEvent(data as INoteTemplate, 'grid');
      }
    };
  }

  openModalNoteTemplate(): void {
    this.noteListModal.open();
  }

  sendLayoutDescriptionNoteAfterClickEvent(noteTemplate: INoteTemplate, source: 'grid' | 'chip'): void {
    switch (source) {
      case 'grid':
        this.noteTemplateService.sendNoteTemplateDataByClick(noteTemplate);
        this.noteListModal.close();
        break;
      case 'chip':
        this.noteTemplateService.sendNoteTemplateDataByClick(noteTemplate);
        break;
    }
  }

  ngOnDestroy(): void {
    this.noteTemplateService.clearNoteTemplateData();
    this.destroy.unsubscribe();
  }
}





// WEBPACK FOOTER //
// ./src/app/utils/note-template-chips/note-template-chips.component.ts